/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type {appConfigs, LoginAppRights, Menu} from '../../components/types/types';
export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  clientId: string;
  clientName?: string;
}
export interface AuthState {
  user: User | null;
  token: string | null;
  role:Role[] | null;
  superadminClientId: string | null;
  appConfigs: appConfigs | null;
  appRights: LoginAppRights[] | null;
}

export interface Role {
    roleID: number;
    roleName: string;
    menu: Menu[];  
    isClientRole?: boolean;
}


const initialState: AuthState = {
  user: (() => {
    const userString = localStorage.getItem('user');
    if (userString === null) return null;
    try {
      return JSON.parse(userString) as User;
    } catch {
      return null;
    }
  })(),
  token: localStorage.getItem('jwtToken') ?? null,
  role: (() => {
    const userString = localStorage.getItem('role');
    if (userString === null) return null;
    try {
      return JSON.parse(userString) as Role[];
    } catch {
      return null;
    }
  })(),
  superadminClientId: localStorage.getItem('superadminClientId') ?? null,
  appConfigs: (() => {
    const appConfig = localStorage.getItem('appConfigs');
    if (appConfig === null) return null;
    try {
      return JSON.parse(appConfig) as appConfigs;
    } catch {
      return null;
    }
  })(),
  appRights: (() => {
    const userString = localStorage.getItem('appRights');
    if (userString === null) return null;
    try {
      return JSON.parse(userString) as LoginAppRights[];
    } catch {
      return null;
    }
  })()
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action: PayloadAction<AuthState>) => {

      console.log('Is frozen:', Object.isFrozen(action.payload.user));
      console.log('Payload user:', action.payload.user);

      const clonedUser: User = action.payload.user ? JSON.parse(JSON.stringify(action.payload.user)) : null;
      Object.defineProperty(clonedUser, 'clientId', {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        value: clonedUser.clientId,
        writable: true,
        enumerable: true,
        configurable: true,
      });
      state.user = clonedUser;

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // state.user = action.payload.user
      // ? {
      //   ...action.payload.user,
      //   }
      // : null;
      state.token = action.payload.token;
      state.role = action.payload.role;
      state.superadminClientId = action.payload.superadminClientId;
      state.appConfigs= action.payload.appConfigs;
      state.appRights= action.payload.appRights;
      if (action.payload.user !== null) {
        localStorage.setItem('user', JSON.stringify(action.payload.user));
      } else {
        localStorage.removeItem('user');
      }
      if (action.payload.token !== null) {
        localStorage.setItem('jwtToken', action.payload.token);
      } else {
        localStorage.removeItem('jwtToken');
      }
      if (action.payload.role !== null) {
        localStorage.setItem('role',  JSON.stringify(action.payload.role));
      } else {
        localStorage.removeItem('role');
      }
      if (action.payload.superadminClientId !== null) {
        localStorage.setItem('superadminClientId',  JSON.stringify(action.payload.superadminClientId));
      } else {
        localStorage.removeItem('superadminClientId');
      }
      if (action.payload.appConfigs !== null) {
        localStorage.setItem('appConfigs',  JSON.stringify(action.payload.appConfigs));
      } else {
        localStorage.removeItem('appConfigs');
      }      
      if (action.payload.appRights !== null) {
        localStorage.setItem('appRights', JSON.stringify(action.payload.appRights));
      } else {
        localStorage.removeItem('appRights');
      }
      
    },
    clearAuthData: (state) => {
      state.user = null;
      state.token = null;
      state.role = null;
      state.superadminClientId = null;
      state.appConfigs = null;
      state.appRights = null;
      localStorage.removeItem('tableauToken');
      localStorage.removeItem('user');
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('role');
      localStorage.removeItem('superadminClientId');
      localStorage.removeItem('appConfigs');
      localStorage.removeItem('appRights');
    },
    
  },
});

export const { setAuthData, clearAuthData } = authSlice.actions;
export default authSlice.reducer;